import React, { useState } from "react";
import { Breadcrumb, Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import styles from "./landing.module.css";

const BreadCrums = ({ crumbs }) => {
	const [t] = useTranslation();
	const [isRTL, setIsRTL] = useState(JSON.parse(localStorage.getItem("isRTL")) || false);

	// Ensure crumbs is always an array
	const validCrumbs = Array.isArray(crumbs) ? crumbs.filter((c) => c && (c.label || c.name)) : [];

	if (validCrumbs.length === 0) return null;

	return (
		<div className={styles.breadcrumbWrapper}>
			<Container>
				<Breadcrumb className={styles.breadcrumbs}>
					<Breadcrumb.Item linkAs={Link} linkProps={{ to: "/" }}>
						{t("Main Page")}
					</Breadcrumb.Item>

					{validCrumbs.map((item, index) => (
						<Breadcrumb.Item
							className={`${styles.breadcrumbEn}`}
							key={index}
							active={index === validCrumbs.length - 1}
							linkAs={index === validCrumbs.length - 1 ? undefined : Link}
							linkProps={index === validCrumbs.length - 1 ? {} : { to: item.to || null }}
						>
							{t(item.label || item.name)}
						</Breadcrumb.Item>
					))}
				</Breadcrumb>
			</Container>
		</div>
	);
};

export default BreadCrums;
